import React from 'react'
import Breadcrub from '../Common/Breadcrub'

const OurManagement = () => {
  return (
    <>
      <Breadcrub title="Our Management"  />
        <section>
            <div class="container">
                <div class="row mb-1-9 mb-xl-2-9">
                    <div class="col-lg-4 mb-1-9 mb-md-2-5 mb-lg-0">
                        <div class="instructor-img-wrapper mb-50 md-mb-0">
                        <div class="mb-1-6 mb-xl-1-9">
                            <img class="border-radius-5" src="img/content/chairman.jpg" alt="..." />
                        </div>
                        <div class="text-center">
                            <h3 class="font-weight-800 display-26 display-md-25 display-xl-24 text-primary">Mr A. A. NAQVI</h3>
                            <p class="alt-font text-secondary font-weight-700 mb-2">Chairman</p>                            
                        </div>
                        {/* <ul class="social-box">
                            <li><a href="#!"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a href="#!"><i class="fab fa-twitter"></i></a></li>
                            <li><a href="#!"><i class="fab fa-instagram"></i></a></li>
                            <li><a href="#!"><i class="fab fa-youtube"></i></a></li>
                            <li><a href="#!"><i class="fab fa-linkedin-in"></i></a></li>
                        </ul> */}
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <div class="ps-lg-1-9 ps-xl-6">
                            <div class="row mb-1-9 mb-xl-2-9">
                                <div class="col-lg-12">
                                    <h4 class="teacher-name mb-4">Chairman’s Message</h4>                                   
                                    <h4 class="text-dark">Dear Prospective Students,</h4>
                                    <p class="alt-font text-color font-weight-500">To allow an assailable opportunity to my young coevals and furnish them as skilled world class professionals for the pharmaceutical world with deep through knowledge, I hereby introducing Mahatma Gandhi Institute of Medical Sciences.</p>
                                    <p class="alt-font text-color font-weight-500">Our focus is to fulfil this commitment by bringing in the philosophy that industry and education must co-exist while knowledge and experience will continuously and dynamically keep the students performing at the peak level, present and in the future. The institute has adopted the best features of the education to equip you with attributes to succeed in fiercely competitive business world with grace and without compromising with universal values.</p>
                                    <p class="alt-font text-color font-weight-500">I am pleased to note the progress that we are proceeding in the direction of establishing this institute one of the biggest pharmaceutical education and research hub in India.</p>
                                    <p class="alt-font text-color font-weight-500">I feel pleasure to join hands with you in relentless pursuit to world-class education with excellence.</p>
                                    <h3 class="alt-font text-color font-weight-500">Mr A. A. NAQVI</h3>
                                    <p className='alt-font text-color font-weight-500'>Chairman</p>
                                </div>
                            </div>                                      
                        </div>
                    </div>
                </div>

                <div class="row mb-1-9 mb-xl-2-9">
                    <div class="col-lg-4 mb-1-9 mb-md-2-5 mb-lg-0">
                        <div class="instructor-img-wrapper mb-50 md-mb-0">
                        <div class="mb-1-6 mb-xl-1-9">
                            <img class="border-radius-5" src="img/content/principal.png" alt="..." />
                        </div>
                        <div class="text-center">
                            <h3 class="font-weight-800 display-26 display-md-25 display-xl-24 text-primary">Mohammad Asif Khan</h3>
                            <p class="alt-font text-secondary font-weight-700 mb-2">Principal </p>                            
                        </div>
                        {/* <ul class="social-box">
                            <li><a href="#!"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a href="#!"><i class="fab fa-twitter"></i></a></li>
                            <li><a href="#!"><i class="fab fa-instagram"></i></a></li>
                            <li><a href="#!"><i class="fab fa-youtube"></i></a></li>
                            <li><a href="#!"><i class="fab fa-linkedin-in"></i></a></li>
                        </ul> */}
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <div class="ps-lg-1-9 ps-xl-6">
                            <div class="row mb-1-9 mb-xl-2-9">
                                <div class="col-lg-12">
                                    <h4 class="teacher-name mb-4">Principal’s Message </h4> 
                                    <p class="alt-font text-color font-weight-500">My hearty welcome to you to MGIMS, a splendid Temple of Learning. You are entering into the arena of higher education where the future is full of opportunities and promises. By choosing to study at MGIMS you will join a friendly and lively community. The academic environment is top-class and provides an ideal foundation for your personal and professional development. </p>
                                    <p class="alt-font text-color font-weight-500">The college provides full support to improve their communication skills, critical thinking abilities, moral values and sense of responsibility. All efforts are made to improve the creativity and problem solving abilities of the students so that they can contribute their best to the society and the country.The infrastructure has been developed with most modern equipment; provisions have also been made to upgrade the same keeping pace with the technological advancements of the time. </p>
                                    <p class="alt-font text-color font-weight-500">We are confident that the students passing out from this college will be technically sound, confident and have good leadership skills.</p>
                                    <p class="alt-font text-color font-weight-500">I wish all the best to all the prospective students.</p>
                                    <h3 class="alt-font text-color font-weight-500">Mohammad Asif Khan </h3>
                                    <p className='alt-font text-color font-weight-500'>Principal </p>
                                </div>
                            </div>                                      
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </>
  )
}

export default OurManagement
